import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';
import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_USERS_V2_ROOT = `${BASE_ADMIN_V2_PATH}/users`;
export const ADMIN_USERS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/users`;

export const ADMIN_USERS_APP_PATHS = {
  USERS_LIST: `${ADMIN_USERS_V2_ROOT}`,
  USER_DETAILS: (userId: string) => `${ADMIN_USERS_V2_ROOT}/${userId}/details`,
  USER_CREATE_ORDER: (userId: string, params?: Record<string, string>) =>
    `${ADMIN_USERS_V2_ROOT}/${userId}/create-order${params ? `?${new URLSearchParams(params).toString()}` : ''}`,
};

export const ADMIN_USERS_API_PATHS = {
  GET_USERS: `${ADMIN_USERS_API_ROOT}`,
  GET_USER_BY_ID: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}`,
  GET_USER_CONTACTS: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}/contacts`,
  CREATE_USER: `${ADMIN_USERS_API_ROOT}`,
  UPDATE_USER: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}`,
  DEACTIVATE_USER: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}`,
  RESTORE_USER: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}/restore`,
  SEND_ECO_WELCOME: (userId: string) => `${ADMIN_USERS_API_ROOT}/${userId}/send-eco-welcome`,
};

// Legacy discounts endpoints, consumed through HttpClient until the module is rebuilt hexagonally.
export const USER_DISCOUNTS_API_PATHS = {
  GET_USER_DISCOUNTS: (userId: string) => `/discounts?owner=${userId}`,
  GET_NEXT_DISCOUNT_CODE: '/discounts/nextOne',
  CREATE_DISCOUNT: '/discounts',
};
